/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Type of translation (AUTOMATIC or MANUAL)
 * @example "MANUAL"
 */
export enum TranslationType {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

/**
 * Deprecated — ASX logic moved to offer-experience-offer-service. Indicates whether the experience includes pickups or not. 'X': Excursion / 'E': Ticket
 * @deprecated
 * @example "X"
 */
export enum ExperienceType {
  X = "X",
  E = "E",
}

/**
 * Type of the voucher
 * @example "MOBILE"
 */
export enum VoucherType {
  MOBILE = "MOBILE",
  PRINTED = "PRINTED",
}

export enum ImageType {
  COVER = "COVER",
  GALLERY = "GALLERY",
}

/**
 * Status of the DAM linking process
 * @example "MEDIA_OK"
 */
export enum ImageStatus {
  MEDIA_PENDING = "MEDIA_PENDING",
  MEDIA_OK = "MEDIA_OK",
}

/**
 * Version status
 * @example "ARCHIVED"
 */
export enum VersionStatus {
  ARCHIVED = "ARCHIVED",
  ACTIVE = "ACTIVE",
}

/**
 * Experience source. Note: SP and ASX values are deprecated.
 * @default "NOVA"
 */
export enum ExperienceSource {
  SP = "SP",
  NOVA = "NOVA",
  SIP = "SIP",
  ASX = "ASX",
  NOVANET = "NOVANET",
  INTERNAL = "INTERNAL",
}

/** @default "NOT_READY" */
export enum GlobalStatus {
  NOT_READY = "NOT_READY",
  PUBLISHED = "PUBLISHED",
  UNPUBLISHED = "UNPUBLISHED",
}

/** @default "NOT_READY" */
export enum OperationalStatus {
  NOT_READY = "NOT_READY",
  READY = "READY",
}

/** @default "NOT_READY" */
export enum DistributionStatus {
  NOT_READY = "NOT_READY",
  READY = "READY",
  SENT = "SENT",
  UNPUBLISHED = "UNPUBLISHED",
}

export enum FlowCode {
  BASE = "BASE",
  CURATION = "CURATION",
}

/** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
export enum StatusCode {
  IN_CREATION = "IN_CREATION",
  BEING_CURATED = "BEING_CURATED",
  UP_TO_DATE = "UP_TO_DATE",
  IN_REVIEW = "IN_REVIEW",
  SENT_TO_REVIEW = "SENT_TO_REVIEW",
  COMPLETED = "COMPLETED",
  ARCHIVED = "ARCHIVED",
}

export enum CurationLevel {
  DEDICATED = "DEDICATED",
  FULL_CURATION = "FULL_CURATION",
  SOFT_CURATION = "SOFT_CURATION",
  SELF_MANAGEMENT = "SELF_MANAGEMENT",
  TO_BE_DEDICATED = "TO_BE_DEDICATED",
  TO_BE_FULL_CURATED = "TO_BE_FULL_CURATED",
  TO_BE_SOFT_CURATED = "TO_BE_SOFT_CURATED",
  TO_BE_SELF_MANAGED = "TO_BE_SELF_MANAGED",
}

/** Option associated with an operational experience */
export interface OperationalExperienceOption {
  /**
   * Option ID
   * @format uuid
   * @example "b7bc9f77-eca8-5c5e-9c8e-4c0678d06067"
   */
  option_id: string;
  /**
   * Operational experience ID this option belongs to
   * @format uuid
   * @example "a6ac8f66-fca7-4b4d-8b7d-3b9567c05956"
   */
  operational_id: string;
  /**
   * Option name
   * @example "Standard Option"
   */
  name: string;
  /**
   * Option code
   * @example "OPT001"
   */
  code?: string;
}

/** Search filters for experiences summary */
export interface ExperienceSearchFilter {
  /**
   * Search by experience title (partial match, case-insensitive)
   * @example "Ski classes"
   */
  title?: string;
  /**
   * Search by reference code (partial match, case-insensitive)
   * @example "CODE1235"
   */
  reference_code?: string;
  /**
   * Filter by exact UUID (matches against experience_id and operational_id)
   * @format uuid
   * @example "3be43767-1234-5678-9abc-def012345678"
   */
  id?: string;
  /** Filter by distribution status */
  global_status?: "NOT_READY" | "PUBLISHED" | "UNPUBLISHED";
  /** Filter by raw workflow status */
  raw_status?:
    | "IN_CREATION"
    | "SENT_TO_REVIEW"
    | "BEING_CURATED"
    | "IN_REVIEW"
    | "COMPLETED"
    | "UP_TO_DATE"
    | "ARCHIVED";
  /** Filter by experience source (experience type) */
  experience_source?: "NOVA" | "SIP" | "NOVANET" | "INTERNAL";
  /**
   * Filter by country ISO alpha-2 code
   * @example "ES"
   */
  country?: string;
  /**
   * Filter by own offer classification code
   * @example "OWN_OFFER_TUI_DESIGNED_OPERATED"
   */
  own_offer_classification?: string;
  /**
   * Filter experiences created on or after this date
   * @format date-time
   */
  creation_date_from?: string;
  /**
   * Filter experiences created on or before this date
   * @format date-time
   */
  creation_date_to?: string;
  /**
   * Filter experiences published on or after this date
   * @format date-time
   */
  publication_date_from?: string;
  /**
   * Filter experiences published on or before this date
   * @format date-time
   */
  publication_date_to?: string;
  /**
   * Sort field. Prefix with - for descending.
   * @example "-creation_date"
   */
  sort?: string;
  /**
   * Offset for pagination
   * @min 0
   * @example 0
   */
  offset?: number;
  /**
   * Number of results to return (default: 50)
   * @min 1
   * @max 1000
   * @default 50
   * @example 50
   */
  limit?: number;
}

/** Experience row for the summary view. For INTERNAL sources, one row per operational. For non-INTERNAL, one row per experience. */
export interface ExperienceOverview {
  /**
   * ExperienceRaw ID (used for CRUD operations on /experience-raw/{id})
   * @format uuid
   * @example "714a259a-65a6-44bf-9ce8-c830dae9c477"
   */
  raw_id?: string;
  /**
   * DistributionContent ID (factsheet)
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  experience_id?: string;
  /**
   * Operational experience ID (only for INTERNAL, null for non-INTERNAL)
   * @format uuid
   * @example "ffa10e64-6b02-404d-9f71-6f851b68661c"
   */
  operational_id?: string | null;
  /**
   * Short reference code
   * @example "EXP0001521"
   */
  reference_code?: string;
  /**
   * Commercial title (for INTERNAL: operational title, for non-INTERNAL: factsheet title)
   * @example "Jet Ski Tour - Morning"
   */
  title?: string;
  /**
   * Distribution status
   * @example "PUBLISHED"
   */
  global_status?: "NOT_READY" | "PUBLISHED" | "UNPUBLISHED";
  /**
   * Raw workflow status
   * @example "UP_TO_DATE"
   */
  raw_status?:
    | "IN_CREATION"
    | "SENT_TO_REVIEW"
    | "BEING_CURATED"
    | "IN_REVIEW"
    | "COMPLETED"
    | "UP_TO_DATE"
    | "ARCHIVED";
  /**
   * Experience source type
   * @example "INTERNAL"
   */
  experience_source?: "NOVA" | "SIP" | "NOVANET" | "INTERNAL";
  /**
   * Supplier ID
   * @format uuid
   * @example "8daacfa6-4836-403e-be27-4a3837779459"
   */
  supplier_id?: string;
  /**
   * Incoming office code
   * @example 5258
   */
  incoming_office?: number;
  /**
   * Country name
   * @example "Italy"
   */
  country?: string;
  /**
   * Country ISO alpha-2 code
   * @example "IT"
   */
  country_iso_code?: string;
  /**
   * Commercial ID / service code
   * @example "NOVA_000123"
   */
  service_code?: string;
  /**
   * Own offer classification code
   * @example "OWN_OFFER_TUI_DESIGNED_OPERATED"
   */
  own_offer_classification?: string | null;
  /**
   * Creation date
   * @format date-time
   */
  creation_date?: string;
  /**
   * Last update date
   * @format date-time
   */
  updated_date?: string;
  /**
   * Last publication date
   * @format date-time
   */
  publication_date?: string | null;
}

export interface Error {
  /** @example "GenericApiException" */
  code?: string;
  /** @example "Error message description" */
  message?: string;
}

export interface ExperienceFunctionalEditorial {
  /** Internal id */
  id?: Id;
  /** Internal id of the experience */
  experience_id?: ExperienceId;
  premades?: FunctionalEditorialPremades;
  settings?: FunctionalEditorialSettings;
  place?: FunctionalEditorialPlace;
  booking_information?: BookingInformation;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface FunctionalEditorialPremades {
  /** Highlights */
  highlights?: Highlights;
  /** What to remember */
  important_information?: ImportantInformation;
  /** What's included */
  included?: Included;
  /** What's non included */
  non_included?: NonIncluded;
}

export interface FunctionalEditorialSettings {
  /** Accessibility tags for the experience */
  accessibility_tags?: AccessibilityTags;
  /** Animal welfare tags */
  animal_welfare_tags?: AnimalWelfareTags;
  /** Health and safety tags */
  health_and_safety_tags?: HealthAndSafetyTags;
  /** Other miscellaneous tags */
  other_tags?: OtherTags;
  /** Experience categories */
  categories?: Categories;
  /** Experience interests */
  interests?: Interests;
  /** Features */
  features?: Features;
  /** Duration of the experience */
  duration?: Duration;
  /** Promotional option */
  promotional_option?: PromotionalOption;
  /** Product brand identifier */
  product_brand?: ProductBrand;
  /** National Geographic tour level */
  nat_geo_tour_level?: NatGeoTourLevel;
  /** Own offer classification */
  own_offer_classification?: OwnOfferClassification;
}

export interface FunctionalEditorialPlace {
  /** List of experience additional cities codes */
  additional_cities?: AdditionalCities;
  address?: Address;
  geolocation?: Geolocation;
  /** List of experience venue codes */
  venues?: Venues;
}

export interface Geolocation {
  /** @example "39.573696612860154" */
  latitude?: string;
  /** @example "2.643315064536297" */
  longitude?: string;
  /** @example "10.0" */
  altitude?: string;
}

/**
 * Accessibility tags for the experience
 * @example ["ACCESSIBILITY_TAGS_SUITABLEFORWHEELCHAI"]
 */
export type AccessibilityTags = string[];

/**
 * Animal welfare tags
 * @example ["ANIMAL_WELFARE_TAGS_CAPTIVEANIMALNOINTE"]
 */
export type AnimalWelfareTags = string[];

/**
 * Health and safety tags
 * @example ["HEALTH_AND_SAFETY_TAGS_ANIMALRIDESCAMEL"]
 */
export type HealthAndSafetyTags = string[];

/**
 * Other miscellaneous tags
 * @example ["OTHER_TAGS_COMPETITIVEOVERLAP"]
 */
export type OtherTags = string[];

/**
 * Duration of the experience
 * @example "DURATION_UP_2"
 */
export type Duration = string;

/**
 * Promotional option
 * @example "PROMOTIONAL_SPECIAL"
 */
export type PromotionalOption = string;

/**
 * Product brand identifier
 * @example "BRAND_NATIONAL_GEOGRAPHIC"
 */
export type ProductBrand = string;

/**
 * National Geographic tour level
 * @example "NAT_GEO_TOUR_LEVEL_MID"
 */
export type NatGeoTourLevel = string;

/**
 * Own offer classification
 * @example "OWN_OFFER_TUI_DESIGNED_OPERATED"
 */
export type OwnOfferClassification = string;

export interface ExperienceCreate {
  metadata: {
    /** Supplier internal unique code */
    supplier_id: SupplierId;
    /** Experience source. Note: SP and ASX values are deprecated. */
    experience_source: ExperienceSource;
  };
  raw: {
    commercial: {
      /** Experience title */
      title: Title;
    };
  };
}

export type Metadata = MetadataCreate &
  MetadataUpdate & {
    /** Reference code */
    reference_code?: ReferenceCode;
    global_status?: GlobalStatus;
    /** Flag for whether the distribution content was created by import */
    imported?: Imported;
  };

export interface MetadataCreate {
  /** Reference code */
  reference_code?: ReferenceCode;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Incoming office code (also known as receptive code for OLP/ASX domain) */
  incoming_office?: IncomingOffice;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Company code */
  company_code?: CompanyCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Office code */
  office_code?: OfficeCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Indicates whether the experience includes pickups or not. 'X': Excursion / 'E': Ticket */
  experience_type?: ExperienceType;
  /** Experience source. Note: SP and ASX values are deprecated. */
  experience_source?: ExperienceSource;
}

export interface MetadataUpdate {
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** External reference code for the functional raw entity */
  external_reference_code?: ExternalReferenceCode;
  curation_level?: CurationLevel;
  /** Priority of the content, with a minimum value of 0. */
  priority?: Priority;
}

/** TUI collection brand information details */
export interface CollectionCriteria {
  /**
   * Exceptional experiences details
   * @example "Discover unique and unforgettable experiences tailored for you"
   */
  exceptional_experiences?: string;
  /**
   * Experiences created with care details
   * @example "Handpicked selections curated with attention to detail and passion"
   */
  created_with_care?: string;
  /**
   * Best value guaranteed experiences details
   * @example "Find the best deals and value for your money"
   */
  best_value_guaranteed?: string;
  /**
   * Guide quote details
   * @example "Discover the perfect balance of luxury, comfort, and adventure"
   */
  guide_quote?: string;
}

/**
 * Itinerary details
 * @example "Discover unique and unforgettable experiences tailored for you"
 */
export type Itinerary = string;

export interface Editorial {
  media_content?: MediaDistribution;
  translations_content?: TranslationDistribution[];
}

export interface MediaDistribution {
  /** Internal id */
  id?: Id;
  status?: DistributionStatus;
  /** Date when sent to distribution */
  distribution_date?: DistributionDate;
}

export type TranslationDistribution = MediaDistribution & {
  /** Language code ISO 639-2 */
  language_code?: LanguageCode;
};

export interface Premades {
  /** Highlights */
  highlights?: Highlights;
  /** What's included */
  included?: Included;
  /** What's non included */
  non_included?: NonIncluded;
  /** What to remember */
  important_information?: ImportantInformation;
  /** Brand */
  brand?: Brand;
  /** Promotional */
  promotional?: Promotional;
  /** Classification */
  classification?: Classification;
  /** Features */
  features?: Features;
  /** Durations */
  durations?: Durations;
  /** Experience categories */
  categories?: Categories;
  /** Experience interests */
  interests?: Interests;
  /** List of experience markets codes */
  markets?: Markets;
}

/** Commercial information  */
export interface Commercial {
  /** Experience title */
  title: Title;
  /** Experience description */
  description?: Description;
  /** Experience additional description */
  additional_description?: AdditionalDescription;
  info_voucher?: InfoVoucher;
  meeting_point_details?: MeetingPointDetails;
  /** Custom Highlights */
  custom_highlights?: CustomHighlights[];
  /** Custom Included */
  custom_included?: CustomIncluded[];
  /** Custom NonIncluded */
  custom_non_included?: CustomNonIncluded[];
  /** Custom Important Information */
  custom_important_information?: CustomImportantInformation[];
}

export interface CustomIncluded {
  /**
   * Internal code for includes
   * @example "local-yhwywrsp5b"
   */
  code?: string;
  /**
   * Name of the includes
   * @example "Entrance fees"
   */
  name: string;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
}

export interface CustomNonIncluded {
  /**
   * Internal code for non includes
   * @example "local-yhwywrsp5c"
   */
  code?: string;
  /**
   * Name of the non includes
   * @example "White shoes only allowed"
   */
  name: string;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
}

export interface CustomHighlights {
  /**
   * Internal code used for custom highlights
   * @example "local-yhwywrsp5a"
   */
  code?: string;
  /**
   * Custom highlight's name
   * @example "Lunch menu to keep you going all the day"
   */
  name: string;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
}

export interface CustomImportantInformation {
  /**
   * Internal code for "things to remember"
   * @example "local-yhwywrsp5d"
   */
  code?: string;
  /**
   * Important information's name
   * @example "Copy of your password"
   */
  name: string;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
}

/** Commercial option element. It can be either premade or custom type, but not both simultaneously */
export interface CommercialOption {
  /** Option id */
  id: OptionId;
  /** Operational reference code (i.eg.: ASX modality code, SIP feature id,...) */
  code?: OptionCode;
  premade_code?: PremadeCode;
  /** Custom free text name value */
  name?: OptionName;
}

/** Operational experience summary */
export interface OperationalExperienceSummary {
  /**
   * Operational experience ID
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  operational_id: string;
  /**
   * Operational experience name
   * @example "Jet Ski Tour"
   */
  name: string;
  /**
   * Operational service code
   * @example "EXP0095272"
   */
  code: string;
}

/** Operational experience with its associated options (for INTERNAL experiences) */
export interface OperationalExperience {
  /**
   * Operational experience ID
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  operational_id: string;
  /**
   * Operational experience name
   * @example "Jet Ski Tour"
   */
  name: string;
  /**
   * Operational service code
   * @example "EXP0095272"
   */
  code: string;
  /** Options associated with this operational experience */
  options: OperationalOption[];
}

/** Option element within an operational experience */
export interface OperationalOption {
  /**
   * Option ID
   * @format uuid
   * @example "a1b2c3d4-e5f6-7890-abcd-000000000001"
   */
  option_id: string;
  /**
   * Option code
   * @example "GENERAL"
   */
  code: string;
  /**
   * Option name
   * @example "Full Day"
   */
  name: string;
}

/**
 * Country calling code
 * @example "+34"
 */
export type CountryCallingCode = string;

/**
 * Phone number
 * @example "600543431"
 */
export type PhoneNumber = string;

/**
 * Flag for whether the distribution content was created by import
 * @example true
 */
export type Imported = boolean;

/**
 * Priority of the content, with a minimum value of 0.
 * @min 0
 */
export type Priority = number;

/**
 * Flag for whether the raw should be auto published
 * @example false
 */
export type AutoPublishFields = boolean;

/**
 * Flag for whether the raw should be manually published
 * @example false
 */
export type ManualPublishFields = boolean;

/**
 * Experience title
 * @example "Navigli Canals of Milan private walking tour with a local guide"
 */
export type Title = string;

/**
 * Experience description
 * @example "This experience is part of STEP, a selection of walking tours designed as a way to discover a destination in more depth, finding hidden gems, meeting the locals and exploring off the beaten path"
 */
export type Description = string;

/**
 * Translation second description.
 * @format string
 * @example "Translation second description"
 */
export type SecondDescription = string;

/**
 * Translation third description.
 * @format string
 * @example "Translation third description"
 */
export type ThirdDescription = string;

/**
 * Experience additional description
 * @example "Walking through the park"
 */
export type AdditionalDescription = string;

/** Highlights */
export type Highlights = string[];

/** What's included */
export type Included = string[];

/** What's non included */
export type NonIncluded = string[];

/** What to remember */
export type ImportantInformation = string[];

/**
 * Brand
 * @example "BRAND_NONE"
 */
export type Brand = string;

/**
 * Promotional
 * @example "PROMOTIONAL_NONE"
 */
export type Promotional = string;

/**
 * Classification
 * @example "OWN_OFFER_TUI_DESIGNED_OPERATED"
 */
export type Classification = string;

/**
 * Features
 * @example ["FEATURE_FREE_CANCELLATION","FEATURE_INSTANT_CONFIRMATION"]
 */
export type Features = string[];

/**
 * Durations
 * @example ["DURATION_6_8","DURATION_2_4"]
 */
export type Durations = string[];

/**
 * Legacy Additional services (deprecated - use typed fields instead)
 * @deprecated
 */
export type AdditionalServicesArray = string[];

/** Experience categories */
export type Categories = string[];

/** Experience interests */
export type Interests = string[];

/** List of experience markets codes */
export type Markets = string[];

/** List of experience additional cities codes */
export type AdditionalCities = string[];

/** List of experience venue codes */
export type Venues = string[];

/** @example "Info voucher" */
export type InfoVoucher = string;

/** @example "Meeting point details" */
export type MeetingPointDetails = string;

/**
 * Option
 * @deprecated
 */
export interface Option {
  /**
   * Option code
   * @example "GENERAL"
   */
  code: string;
  /** @example "Full day" */
  description: string;
}

/**
 * Functional information.
 *
 * **Mutual exclusion**: use either `additional_services` (legacy, deprecated) OR the new typed fields
 * (`product_brand`, `promotional_option`, `own_offer_classification`, `duration`, `features`,
 * `accessibility_tags`, `animal_welfare_tags`, `health_and_safety_tags`, `other_tags`, `nat_geo_tour_level`).
 * Providing both simultaneously results in a `400 Bad Request`.
 */
export interface FunctionalRaw {
  /** External reference code for the functional raw entity */
  external_reference_code?: ExternalReferenceCode;
  /**
   * Options
   * @deprecated
   */
  options?: Option[];
  /** Highlights */
  highlights?: Highlights;
  /** What's included */
  included?: Included;
  /** What's non included */
  non_included?: NonIncluded;
  /** What to remember */
  important_information?: ImportantInformation;
  /** Legacy Additional services */
  additional_services?: string[];
  /** Experience distribution features. */
  features?: string[];
  /** Accessibility tags for the experience */
  accessibility_tags?: AccessibilityTags;
  /** Animal welfare tags */
  animal_welfare_tags?: AnimalWelfareTags;
  /** Health and safety tags */
  health_and_safety_tags?: HealthAndSafetyTags;
  /** Other miscellaneous tags */
  other_tags?: OtherTags;
  /** Duration of the experience */
  duration?: Duration;
  /** Promotional option */
  promotional_option?: PromotionalOption;
  /** Own offer classification */
  own_offer_classification?: OwnOfferClassification;
  /** Product brand identifier */
  product_brand?: ProductBrand;
  /** National Geographic tour level */
  nat_geo_tour_level?: NatGeoTourLevel;
  /** Experience categories */
  categories?: Categories;
  /** Experience interests */
  interests?: Interests;
  location?: Location;
  /** List of experience markets codes */
  markets?: Markets;
  /** List of experience additional cities codes */
  additional_cities?: AdditionalCities;
  booking_information?: BookingInformation;
  /** List of experience venue codes */
  venues?: Venues;
}

/** Commercial information  */
export interface CommercialRaw {
  /** Experience title */
  title: Title;
  /** Experience description */
  description?: Description;
  /** Experience additional description */
  additional_description?: AdditionalDescription;
  info_voucher?: InfoVoucher;
  meeting_point_details?: MeetingPointDetails;
  /** Experience options (used for non-INTERNAL experiences) */
  options?: CommercialOption[];
  /** Operational experiences with their options (used for INTERNAL experiences). Mutually exclusive with 'options'. */
  operational_experiences?: OperationalExperience[];
  /** Custom Highlights */
  custom_highlights?: CustomHighlights[];
  /** Custom Included */
  custom_included?: CustomIncluded[];
  /** Custom NonIncluded */
  custom_non_included?: CustomNonIncluded[];
  /** Custom Important Information */
  custom_important_information?: CustomImportantInformation[];
}

export interface RawElement {
  /** Internal id */
  id?: Id;
  /** Internal id of the experience */
  experience_id: ExperienceId;
  /** Commercial content reference. The field can store the Charlie's factsheet reference for OPINOIA experiences migration. */
  commercial_id?: CommercialId;
  /**
   * Functional information.
   *
   * **Mutual exclusion**: use either `additional_services` (legacy, deprecated) OR the new typed fields
   * (`product_brand`, `promotional_option`, `own_offer_classification`, `duration`, `features`,
   * `accessibility_tags`, `animal_welfare_tags`, `health_and_safety_tags`, `other_tags`, `nat_geo_tour_level`).
   * Providing both simultaneously results in a `400 Bad Request`.
   */
  functional?: FunctionalRaw;
  /** Commercial information  */
  commercial: CommercialRaw;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code: StatusCode;
  flow_code: FlowCode;
  /** TUI collection brand information details */
  collection_criteria?: CollectionCriteria;
  /** Itinerary details */
  itinerary?: Itinerary;
  media?: RawMedia;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface RawSnapshot {
  /**
   * Experience id
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  id?: string;
  /** Creation date */
  snapshot_date?: CreationDate;
  /**
   * ID version
   * @example "v1"
   */
  version_id?: string;
  /**
   * User version
   * @example "marco.rossi@tui.com"
   */
  user_version?: string;
  raw?: RawElement;
}

export interface Snapshot {
  /** Internal id */
  id?: Id;
  /** Reference code */
  reference_code?: ReferenceCode;
  /** Internal id of the experience */
  experience_id?: ExperienceId;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Incoming office code (also known as receptive code for OLP/ASX domain) */
  incoming_office?: IncomingOffice;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Company code */
  company_code?: CompanyCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Office code */
  office_code?: OfficeCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Indicates whether the experience includes pickups or not. 'X': Excursion / 'E': Ticket */
  experience_type?: ExperienceType;
  /** ID version */
  version_id?: VersionId;
  /** Version status */
  version_status?: VersionStatus;
  /** User version */
  user_version?: User;
  /**
   * Versioning notes
   * @example "versioning notes"
   */
  additional_notes?: string;
  experience_commercial_information?: ExperienceCommercialInformation;
  experience_functional_information?: ExperienceFunctionallInformation;
}

export interface DistributionContentUpdate {
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  curation_level?: CurationLevel;
  /** Priority of the content, with a minimum value of 0. */
  priority?: Priority;
  /** Flag for whether the distribution content was created by import */
  imported?: Imported;
  /**
   * Deprecated — replaced by operational title in experience_operational_translation.
   * Preserve the original commercial title of the experience at the moment of creation.
   * **Required when experience_source is 'INTERNAL'**, optional for other sources.
   */
  internal_title?: InternalTitle;
}

export interface DistributionContent {
  /** Internal id */
  id?: Id;
  /** Reference code */
  reference_code?: ReferenceCode;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** Experience source. Note: SP and ASX values are deprecated. */
  experience_source?: ExperienceSource;
  incoming_office?: IncomingOffice;
  company_code?: CompanyCode;
  office_code?: OfficeCode;
  experience_type?: ExperienceType;
  media_content?: MediaContent;
  translation_content_list?: TranslationContent[];
  global_status?: GlobalStatus;
  curation_level?: CurationLevel;
  /** Priority of the content, with a minimum value of 0. */
  priority?: Priority;
  /** Flag for whether the distribution content was created by import */
  imported?: Imported;
  operational_content?: OperationalContent;
  /**
   * Deprecated — replaced by operational title in experience_operational_translation.
   * Preserve the original commercial title of the experience at the moment of creation.
   * **Required when experience_source is 'INTERNAL'**, optional for other sources.
   */
  internal_title?: InternalTitle;
}

export interface GeneralInformation {
  /**
   * Deprecated — replaced by operational title in experience_operational_translation.
   * Preserve the original commercial title of the experience at the moment of creation.
   * **Required when experience_source is 'INTERNAL'**, optional for other sources.
   */
  internal_title?: InternalTitle;
  /** External reference code for the functional raw entity */
  external_reference_code?: ExternalReferenceCode;
  /** Experience categories */
  categories?: Categories;
  /** Experience interests */
  interests?: Interests;
  /** List of experience markets codes */
  markets?: Markets;
  /** Legacy Additional services (deprecated - use typed fields instead) */
  features?: AdditionalServicesArray;
  /** Legacy Additional services (deprecated - use typed fields instead) */
  accessibility_tags?: AdditionalServicesArray;
  /** Legacy Additional services (deprecated - use typed fields instead) */
  animal_welfare_tags?: AdditionalServicesArray;
  /** Legacy Additional services (deprecated - use typed fields instead) */
  health_and_safety_tags?: AdditionalServicesArray;
  /** Legacy Additional services (deprecated - use typed fields instead) */
  other_tags?: AdditionalServicesArray;
  /**
   * Duration of the experience
   * @example "DURATION_UP_2"
   */
  duration?: string;
  /**
   * Promotional option
   * @example "PROMOTIONAL_EXCEPTIONAL_EXPERIENCES"
   */
  promotional_option?: string;
  /**
   * Product brand
   * @example "BRAND_NATIONAL_GEOGRAPHIC"
   */
  product_brand?: string;
  emergency_contact_number?: ContactNumber;
  /** Type of the voucher */
  voucher_type?: VoucherType;
  location?: Location;
  /** List of experience additional cities codes */
  additional_cities?: AdditionalCities;
  /** List of experience venue codes */
  venues?: Venues;
}

export interface ExperienceContent {
  /** Internal id */
  id: Id;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** Experience source. Note: SP and ASX values are deprecated. */
  experience_source?: ExperienceSource;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Incoming office code (also known as receptive code for OLP/ASX domain) */
  incoming_office?: IncomingOffice;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Company code */
  company_code?: CompanyCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Office code */
  office_code?: OfficeCode;
  /** Deprecated — ASX logic moved to offer-experience-offer-service. Indicates whether the experience includes pickups or not. 'X': Excursion / 'E': Ticket */
  experience_type?: ExperienceType;
  general_information?: GeneralInformation;
  media?: Media;
  premades?: ExperienceContentPremade;
  /** Translations */
  translations?: ExperienceContentTranslation[];
  /**
   * Entity version
   * @format int64
   */
  version?: number;
}

export interface MediaContent {
  /** Date when sent to distribution */
  distribution_date?: DistributionDate;
  /** Internal id */
  id?: Id;
  distribution_status?: DistributionStatus;
}

export interface Image {
  /** File name of the image */
  file_name?: FileName;
  /** Preview URL of the image */
  preview_url?: PreviewUrl;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
  image_type?: ImageType;
}

export interface SnapshotPremadeOption {
  /** Internal id */
  id: Id;
  /** Option id */
  option_id: OptionId;
  /** Operational reference code (i.eg.: ASX modality code, SIP feature id,...) */
  code?: OptionCode;
  premade_code: PremadeCode;
  /**
   * Operational experience ID
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  operational_id?: string;
  /** Last updated  date */
  updated_date?: UpdatedDate;
  /** Creation date */
  creation_date: CreationDate;
}

export interface ExperienceContentPremadeOption {
  /** Option id */
  id: OptionId;
  /** Operational reference code (i.eg.: ASX modality code, SIP feature id,...) */
  code?: OptionCode;
  premade_code: PremadeCode;
}

export interface Media {
  images?: Image[];
}

/**
 * Deprecated — replaced by operational title in experience_operational_translation.
 * Preserve the original commercial title of the experience at the moment of creation.
 * **Required when experience_source is 'INTERNAL'**, optional for other sources.
 * @deprecated
 * @example "Walking the dog"
 */
export type InternalTitle = string;

export interface OperationalContent {
  /** Internal id */
  id?: Id;
  distribution_status?: OperationalStatus;
  /** Date when sent to distribution */
  distribution_date?: DistributionDate;
}

export interface RawMedia {
  images?: RawImage[];
}

export interface RawImage {
  /** File name of the image */
  file_name?: FileName;
  /** Preview URL of the image */
  preview_url?: PreviewUrl;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
  image_type?: ImageType;
  /** Status of the DAM linking process */
  status?: ImageStatus;
  /** Unique identifier for a batch of raw images */
  batch_id?: BatchId;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface TranslationContent {
  /** Date when sent to distribution */
  distribution_date?: DistributionDate;
  /** Internal id */
  id?: Id;
  /** Language code ISO 639-2 */
  language_code: LanguageCode;
  distribution_status?: DistributionStatus;
}

export interface ExperienceCommercialInformation {
  /**
   * Deprecated — replaced by operational title in experience_operational_translation.
   * Preserve the original commercial title of the experience at the moment of creation.
   * **Required when experience_source is 'INTERNAL'**, optional for other sources.
   */
  internal_title?: InternalTitle;
  experience_media?: ExperienceMedia;
  premades?: SnapshotPremade;
  translations?: Translation[];
}

export interface ExperienceMedia {
  /** Internal id */
  id?: Id;
  flow_code?: FlowCode;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code?: StatusCode;
  images?: Image[];
}

export interface SnapshotPremade {
  options?: SnapshotPremadeOption[];
}

export interface ExperienceContentPremade {
  options?: ExperienceContentPremadeOption[];
}

export interface Translation {
  /** Language code ISO 639-2 */
  language_code?: LanguageCode;
  experience_translation?: ExperienceTranslation;
  customs?: CustomTranslations;
  options?: SnapshotTranslationOption[];
  /** Operational translations for internal experiences */
  operational_translations?: OperationalTranslation[];
}

export interface ExperienceTranslation {
  /** Internal id */
  id?: Id;
  /** Experience title */
  title?: Title;
  /** Experience description */
  text1?: Description;
  /** Translation second description. */
  text2?: SecondDescription;
  /** Translation third description. */
  text3?: ThirdDescription;
  /** Experience title */
  seo_title?: Title;
  /** Experience description */
  seo_description?: Description;
  info_voucher?: InfoVoucher;
  meeting_point_details?: MeetingPointDetails;
  flow_code?: FlowCode;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code?: StatusCode;
  /** Curation quality */
  curation_quality?: CurationQuality;
  /** Name of the entity */
  name?: Name;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
  /** Type of translation (AUTOMATIC or MANUAL) */
  translation_type?: TranslationType;
}

/** Operational translation for internal experiences */
export interface OperationalTranslation {
  /**
   * Operational experience ID
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  operational_id: string;
  /**
   * Operational code
   * @example "EXP_CODE_001"
   */
  code?: string;
  /**
   * Translated operational title
   * @example "Beach Experience"
   */
  name: string;
  flow_code?: FlowCode;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code?: StatusCode;
  /**
   * Automatic translation flag
   * @example false
   */
  automatic_translation?: boolean;
}

export interface CustomTranslations {
  custom_highlights?: CustomContent[];
  custom_included?: CustomContent[];
  custom_non_included?: CustomContent[];
  custom_important_information?: CustomContent[];
}

export interface ExperienceContentTranslation {
  /** Language code ISO 639-2 */
  language_code?: LanguageCode;
  /** Experience title */
  title?: Title;
  /** Experience description */
  text1?: Description;
  /** Translation second description. */
  text2?: SecondDescription;
  /** Translation third description. */
  text3?: ThirdDescription;
  /** Experience title */
  seo_title?: Title;
  /** Experience description */
  seo_description?: Description;
  info_voucher?: InfoVoucher;
  meeting_point_details?: MeetingPointDetails;
  /** Experience description */
  description?: Description;
  /** Type of translation (AUTOMATIC or MANUAL) */
  translation_type?: TranslationType;
  /** Highlights */
  highlights?: Highlights;
  /** What's included */
  included?: Included;
  /** What's non included */
  non_included?: NonIncluded;
  /** What to remember */
  important_information?: ImportantInformation;
  booking_questions?: BookingQuestion;
  options?: ExperienceContentTranslationOption;
}

export interface CustomContent {
  /** Internal id */
  id?: Id;
  /** Code of the translatable entity */
  code?: Code;
  /** Name of the entity */
  name?: Name;
  /** Experience description */
  description?: Description;
  /** Flag for automatic translation */
  automatic_translation?: AutomaticTranslation;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
  flow_code?: FlowCode;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code?: StatusCode;
}

export interface ExperienceFunctionallInformation {
  highlights?: FunctionalItem;
  included?: FunctionalItem;
  excluded?: FunctionalItem;
  important_information?: FunctionalItem;
  additional_services?: AdditionalServices;
  categories?: FunctionalItem;
  interests?: FunctionalItem;
  markets?: FunctionalItem;
  additional_cities?: FunctionalItem;
  venues?: FunctionalItem;
  booking_information?: ExperienceBookingInformation;
  booking_questions?: BookingQuestion[];
  location?: ExperienceLocation;
  /** External reference code for the functional raw entity */
  external_reference_code?: ExternalReferenceCode;
}

export interface FunctionalItem {
  /** Internal id */
  id?: Id;
  codes?: Code[];
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export type AdditionalServices = FunctionalItem & {
  /**
   * Features/tags codes
   * @example ["FEATURE_FREE_CANCELLATION","FEATURE_INSTANT_CONFIRMATION"]
   */
  features?: string[];
  /**
   * Accessibility tags for the experience
   * @example ["ACCESSIBILITY_TAGS_WHEELCHAIR"]
   */
  accessibility_tags?: string[];
  /**
   * Animal welfare tags
   * @example ["ANIMAL_WELFARE_TAGS_INTERACTIVEWILDLIFE"]
   */
  animal_welfare_tags?: string[];
  /**
   * Health and safety tags
   * @example ["HEALTH_AND_SAFETY_TAGS_ANIMALRIDESCAMEL"]
   */
  health_and_safety_tags?: string[];
  /**
   * Other miscellaneous tags
   * @example ["OTHER_TAGS_GREENANDFAIR"]
   */
  other_tags?: string[];
  /**
   * Duration of the experience
   * @example "DURATION_UP_2"
   */
  duration?: string;
  /**
   * Promotional option code
   * @example "PROMOTIONAL_EXCEPTIONAL_EXPERIENCES"
   */
  promotional_option?: string;
  /**
   * Product brand code
   * @example "BRAND_NATIONAL_GEOGRAPHIC"
   */
  product_brand?: string;
  /**
   * Own offer classification
   * @example "3P_OPERATED_3P_DESIGNED"
   */
  own_offer_classification?: string;
  /**
   * National Geographic tour level
   * @example "LEVEL_1"
   */
  nat_geo_tour_level?: string;
};

export interface ExperienceBookingInformation {
  /** Internal id */
  id?: Id;
  information?: BookingInformation;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface BookingInformation {
  /** Type of the voucher */
  voucher_type?: VoucherType;
  emergency_contact_number?: ContactNumber;
}

export interface ContactNumber {
  /**
   * country calling code
   * @example "+34"
   */
  country_calling_code: string;
  /**
   * phone number
   * @example "600543431"
   */
  number: string;
}

export interface Location {
  /** Option id */
  option_id?: OptionId;
  /**
   * Latitude is the measurement of distance north or south of the Equator.
   * @example "39.573696612860154"
   */
  latitude?: string;
  /**
   * Longitude is the measurement east or west of the prime meridian.
   * @example "2.643315064536297"
   */
  longitude?: string;
  /**
   * Altitude is the measurement of the height in relation to the sea level
   * @example "10.0"
   */
  altitude?: string;
  /**
   * Name of the location
   * @example "New York City"
   */
  name?: string;
  address?: Address;
}

export type ExperienceLocation = {
  /** Internal id */
  id?: Id;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
} & Location;

export interface Address {
  /**
   * Direction of the address
   * @example "CL Veracruz. 16. 4B"
   */
  direction?: string;
  /**
   * Internal TUI Code of cities
   * @example "Mexico City"
   */
  city?: string;
  /**
   * Postal code of the address
   * @example "91709"
   */
  postal_code?: string;
  /**
   * Code from masterdata ISO for a country
   * @example "ESP"
   */
  country?: string;
  /**
   * Country ISO code alpha-2
   * @example "ES"
   */
  country_iso_code_alpha2?: string;
}

export interface BookingQuestion {
  /** Internal id */
  id?: Id;
  /** Option id */
  option_id?: OptionId;
  questions?: Question[];
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface Question {
  /** Code of the translatable entity */
  code?: Code;
  /**
   * Flag for whether the booking question is mandatory
   * @example true
   */
  is_mandatory?: boolean;
  /**
   * Flag for whether the booking question applies to all passengers
   * @example false
   */
  is_apply_all?: boolean;
  /** Visualization Order */
  visualization_order?: VisualizationOrder;
}

/**
 * Language code ISO 639-2
 * @example "en"
 */
export type LanguageCode = string;

/**
 * Reference code
 * @minLength 10
 * @maxLength 10
 * @example "EXP0002301"
 */
export type ReferenceCode = string;

/**
 * Supplier internal unique code
 * @format uuid
 * @example "7e87fdf3-e96d-4783-9dac-2ecb957cf943"
 */
export type SupplierId = string;

/**
 * Internal id
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type Id = string;

/**
 * Option id
 * @format uuid
 * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
 */
export type OptionId = string;

/** @example "2-day-meal" */
export type PremadeCode = string;

/**
 * Custom free text name value
 * @example "Option 1"
 */
export type OptionName = string;

/**
 * Internal id of the experience
 * @format uuid
 * @example "c8ff6bf2-9c04-42d5-996f-4e23636769f4"
 */
export type ExperienceId = string;

/**
 * Commercial content reference. The field can store the Charlie's factsheet reference for OPINOIA experiences migration.
 * @example "13054"
 */
export type CommercialId = string;

/**
 * External reference code for the functional raw entity
 * @example "CVG675-90PLJ89012"
 */
export type ExternalReferenceCode = string;

/**
 * User version
 * @example "marco.rossi@tui.com"
 */
export type User = string;

/**
 * Creation date
 * @format date-time
 * @example "2011-05-20T12:49:08.87914Z"
 */
export type CreationDate = string;

/**
 * Last updated  date
 * @format date-time
 * @example "2011-05-20T12:49:08.87914Z"
 */
export type UpdatedDate = string;

/**
 * Created By user
 * @example "marco.rossi"
 */
export type CreatedByUser = string;

/**
 * Updated By user
 * @example "marco.pantani"
 */
export type UpdatedByUser = string;

/**
 * Date when sent to distribution
 * @format date-time
 * @example "2011-05-20T12:49:08.87914Z"
 */
export type DistributionDate = string;

/**
 * ID version
 * @example "v1"
 */
export type VersionId = string;

/**
 * Visualization Order
 * @example 1
 */
export type VisualizationOrder = number;

/**
 * Unique identifier for a batch of raw images
 * @format uuid
 * @example "3634f03e-7c94-444b-bad3-cb815c2e3b6f"
 */
export type BatchId = string;

/**
 * File name of the image
 * @example "boat_experience_image"
 */
export type FileName = string;

/**
 * Preview URL of the image
 * @example "https://fotoware.com/images/boat_experience_image.jpg"
 */
export type PreviewUrl = string;

/**
 * Curation quality
 * @example "TBD"
 */
export type CurationQuality = string;

/**
 * Name of the entity
 * @example "Entity name"
 */
export type Name = string;

/**
 * Code of the translatable entity
 * @example "LUNCH"
 */
export type Code = string;

/**
 * Operational reference code (i.eg.: ASX modality code, SIP feature id,...)
 * @example "GENERAL"
 */
export type OptionCode = string;

/**
 * Flag for automatic translation
 * @example true
 */
export type AutomaticTranslation = boolean;

export interface ExperienceExternalCatalog {
  /**
   * Unique identifier for the catalog entry
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  id?: string;
  /**
   * Unique Identifier of the experience in SIP with the prefix e.g. 'bokun-' added
   * @example "bokun-123456"
   */
  sip_id?: string;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /**
   * Name of the experience as it appears in SIP
   * @example "Sunset Cruise"
   */
  sip_name?: string;
  /**
   * Indicates if the SIP experience is linked with an experience in NOVA
   * @example false
   */
  linked?: boolean;
  /** Reference code */
  reference_code?: ReferenceCode;
  /** Internal id of the experience */
  experience_id?: ExperienceId;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface ExternalCatalogLinkRequestDto {
  /** Internal id of the experience */
  experience_id: ExperienceId;
  /**
   * NOVA's reference code of the experience
   * @example "EXP000251"
   */
  reference_code: string;
  /**
   * The ID of the previous link to remove (if any)
   * @format uuid
   * @example "5f73fa8c-2c7c-41b1-91c9-34fa4c888df9"
   */
  previous_link_id_to_remove?: string;
}

export interface TranslationSnapshot {
  /**
   * UUID of the snapshot
   * @format uuid
   * @example "5281000c-952f-4ed0-9ca5-a63d1b653041"
   */
  id?: string;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** Internal id of the experience */
  experience_id?: ExperienceId;
  /**
   * Date when the snapshot was created
   * @format date-time
   * @example "2023-10-05T12:34:56.789Z"
   */
  creation_date?: string;
  /**
   * User version
   * @example "test@tui.com"
   */
  user_version?: string;
  /**
   * User who last modified this snapshot
   * @example "john.doe@tui.com"
   */
  modified_by_user?: string;
  /**
   * Status of the version
   * @example "ARCHIVED"
   */
  version_status?: "ARCHIVED" | "ACTIVE" | "DRAFT";
  /**
   * Language code for the translation
   * @example "en"
   */
  language_code?: string;
  /**
   * Code of the flow of the translation
   * @example "CURATION"
   */
  flow_code?: string;
  /**
   * Code of the status of the translation
   * @example "TO_BE_EDITED"
   */
  status_code?: string;
  /**
   * Date when the translation was last updated
   * @format date-time
   * @example "2023-10-10T08:22:33.456Z"
   */
  update_date?: string;
}

export interface MediaSnapshot {
  /** Internal id */
  id?: Id;
  /** Internal id of the experience */
  experience_id?: ExperienceId;
  /** Supplier internal unique code */
  supplier_id?: SupplierId;
  /** ID version */
  version_id?: VersionId;
  /** Version status */
  version_status?: VersionStatus;
  /** User version */
  user_version?: User;
  /**
   * Date when the snapshot was created
   * @format date-time
   * @example "2023-10-05T12:34:56.789Z"
   */
  creation_date?: string;
  media?: ExperienceMedia;
}

/**
 * Deprecated — ASX logic moved to offer-experience-offer-service. Incoming office code (also known as receptive code for OLP/ASX domain)
 * @deprecated
 * @example "5258"
 */
export type IncomingOffice = string;

/**
 * Deprecated — ASX logic moved to offer-experience-offer-service. Company code
 * @deprecated
 * @example "AD0"
 */
export type CompanyCode = string;

/**
 * Deprecated — ASX logic moved to offer-experience-offer-service. Office code
 * @deprecated
 * @example 15
 */
export type OfficeCode = number;

export interface SnapshotTranslationOption {
  /** Internal id */
  id: Id;
  /** Option id */
  option_id: OptionId;
  /**
   * Operational experience ID this option belongs to. NULL for NON-INTERNAL, present for INTERNAL.
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440011"
   */
  operational_id?: string | null;
  /** Operational reference code (i.eg.: ASX modality code, SIP feature id,...) */
  code?: OptionCode;
  /** Custom free text name value */
  name?: OptionName;
  /**
   * Flag for automatic translation
   * @example false
   */
  automatic_translation?: boolean;
  flow_code?: FlowCode;
  /** Raw workflow status. COMPLETED is deprecated — for shared factsheet (INTERNAL) */
  status_code?: StatusCode;
  /** Creation date */
  creation_date?: CreationDate;
  /** Last updated  date */
  updated_date?: UpdatedDate;
}

export interface ExperienceContentTranslationOption {
  /** Internal id */
  id: Id;
  /** Operational reference code (i.eg.: ASX modality code, SIP feature id,...) */
  code?: OptionCode;
  /** Custom free text name value */
  name: OptionName;
}

export interface BatchNotificationResponse {
  /**
   * Identifier of the published batch notification event
   * @format uuid
   * @example "6ef573e9-e0fc-4185-886b-1b28a64381e9"
   */
  eventId: string;
  /**
   * Notification type code used by the notification service
   * @example "nova.translator.recap.email"
   */
  notificationCode: string;
  /**
   * Event creation timestamp
   * @format date-time
   * @example "2024-01-15T10:30:00.000Z"
   */
  timestamp: string;
  /**
   * Status message confirming event publication
   * @example "Batch notification event published to Kafka successfully"
   */
  message: string;
}
